import { BrowserRouter } from "react-router-dom";

import { AnalyticsProvider } from "../contexts/Analytics";
import { PremiumProvider } from "../contexts/Premium";
import SupportChat from "../shared/components/SupportChat";
import RedwingRoutes from "./Routes";

export default function AppNavigator() {
  return (
    <PremiumProvider>
      <AnalyticsProvider>
        <BrowserRouter>
          <RedwingRoutes />
          <SupportChat />
        </BrowserRouter>
      </AnalyticsProvider>
    </PremiumProvider>
  );
}
